// industryTaxonomy.ts
// TypeScript version of the industry taxonomy for admin console
// Mirrors the mobile app's utils/industryTaxonomy.js

interface Profession {
  name: string;
  focusTypes: string[];
}

interface IndustryItem {
  industry: string;
  professions: Profession[];
}

export const INDUSTRY_TAXONOMY: IndustryItem[] = [
  {
    industry: 'Legal Services',
    professions: [
      {
        name: 'Attorney/Lawyer',
        focusTypes: [
          'Personal Injury',
          'Family Law',
          'Criminal Defense',
          'Estate Planning & Probate',
          'Business & Corporate',
          'Real Estate',
          'Immigration',
          'Bankruptcy',
          'Employment & Labor',
          'Intellectual Property',
          'Medical Malpractice',
          'Tax Law',
          'Civil Rights',
          'Environmental Law',
          'Entertainment Law',
        ],
      },
      { name: 'Paralegal Services', focusTypes: [] },
      { name: 'Legal Document Preparation', focusTypes: [] },
      { name: 'Notary Public', focusTypes: [] },
      { name: 'Process Server', focusTypes: [] },
      { name: 'Bail Bonds', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Medical & Healthcare',
    professions: [
      {
        name: 'Physician/Doctor',
        focusTypes: [
          'Primary Care / Family Medicine',
          'Internal Medicine',
          'Cardiology',
          'Dermatology',
          'Gastroenterology',
          'Neurology',
          'Orthopedics',
          'Pediatrics',
          'Psychiatry',
          'Pulmonology',
          'Rheumatology',
          'Urology',
          'Oncology',
          'Endocrinology',
          'Nephrology',
          'Ophthalmology',
          'ENT (Otolaryngology)',
          'Allergy & Immunology',
          'Sports Medicine',
          'Pain Management',
          'Geriatrics',
          'Infectious Disease',
        ],
      },
      {
        name: 'Dentist',
        focusTypes: [
          'General Dentistry',
          'Cosmetic Dentistry',
          'Orthodontics',
          'Periodontics',
          'Endodontics (Root Canal)',
          'Oral Surgery',
          'Pediatric Dentistry',
          'Prosthodontics',
          'Implant Dentistry',
        ],
      },
      { name: 'Chiropractor', focusTypes: [] },
      { name: 'Physical Therapist', focusTypes: [] },
      { name: 'Occupational Therapist', focusTypes: [] },
      {
        name: 'Mental Health Professional',
        focusTypes: [
          'Psychologist',
          'Licensed Therapist/Counselor',
          'Marriage & Family Therapist',
          'Addiction Counselor',
          'Child Psychologist',
          'Trauma Specialist',
        ],
      },
      { name: 'Optometrist', focusTypes: [] },
      { name: 'Audiologist', focusTypes: [] },
      { name: 'Podiatrist', focusTypes: [] },
      { name: 'Acupuncturist', focusTypes: [] },
      { name: 'Naturopathic Doctor', focusTypes: [] },
      { name: 'Nurse Practitioner', focusTypes: [] },
      { name: 'Physician Assistant', focusTypes: [] },
      { name: 'Home Health Care', focusTypes: [] },
      { name: 'Medical Equipment & Supplies', focusTypes: [] },
      { name: 'Speech Therapist', focusTypes: [] },
      { name: 'Dietitian/Nutritionist', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Automotive Services',
    professions: [
      {
        name: 'Auto Sales',
        focusTypes: [
          'New Vehicles',
          'Used Vehicles',
          'Certified Pre-Owned',
          'Luxury/Exotic Vehicles',
          'Commercial Vehicles',
          'Motorcycles',
          'RVs & Campers',
          'Boats & Watercraft',
        ],
      },
      {
        name: 'Auto Repair & Maintenance',
        focusTypes: [
          'General Repair',
          'Transmission',
          'Engine Repair',
          'Brake Service',
          'Electrical Systems',
          'Air Conditioning',
          'Exhaust Systems',
        ],
      },
      { name: 'Auto Body Shop', focusTypes: [] },
      { name: 'Auto Detailing', focusTypes: [] },
      { name: 'Tire Services', focusTypes: [] },
      { name: 'Towing & Roadside Assistance', focusTypes: [] },
      { name: 'Auto Glass Repair', focusTypes: [] },
      { name: 'Car Broker', focusTypes: [] },
      { name: 'Mobile Mechanic', focusTypes: [] },
      { name: 'Fleet Services', focusTypes: [] },
      { name: 'Auto Upholstery', focusTypes: [] },
      { name: 'Window Tinting', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Home Services',
    professions: [
      { name: 'Plumber', focusTypes: [] },
      { name: 'Electrician', focusTypes: [] },
      { name: 'HVAC Technician', focusTypes: [] },
      { name: 'Roofer', focusTypes: [] },
      { name: 'Painter', focusTypes: [] },
      { name: 'Landscaper', focusTypes: [] },
      { name: 'Handyman', focusTypes: [] },
      { name: 'Cleaning Service', focusTypes: [] },
      { name: 'Carpet Cleaning', focusTypes: [] },
      { name: 'Window Cleaning', focusTypes: [] },
      { name: 'Pressure Washing', focusTypes: [] },
      { name: 'Pest Control', focusTypes: [] },
      { name: 'Pool Service', focusTypes: [] },
      { name: 'Garage Door Service', focusTypes: [] },
      { name: 'Locksmith', focusTypes: [] },
      { name: 'Appliance Repair', focusTypes: [] },
      { name: 'Septic Service', focusTypes: [] },
      { name: 'Gutter Service', focusTypes: [] },
      { name: 'Chimney Service', focusTypes: [] },
      { name: 'Home Inspection', focusTypes: [] },
      { name: 'Mold Remediation', focusTypes: [] },
      { name: 'Water Damage Restoration', focusTypes: [] },
      { name: 'Fire Damage Restoration', focusTypes: [] },
      { name: 'Home Organizer', focusTypes: [] },
      { name: 'Junk Removal', focusTypes: [] },
      { name: 'Moving Services', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Construction & Contractors',
    professions: [
      { name: 'General Contractor', focusTypes: [] },
      { name: 'Kitchen & Bath Remodeler', focusTypes: [] },
      { name: 'Flooring Contractor', focusTypes: [] },
      { name: 'Concrete Contractor', focusTypes: [] },
      { name: 'Fencing Contractor', focusTypes: [] },
      { name: 'Deck & Patio Builder', focusTypes: [] },
      { name: 'Siding Contractor', focusTypes: [] },
      { name: 'Masonry Contractor', focusTypes: [] },
      { name: 'Foundation Specialist', focusTypes: [] },
      { name: 'Framing Contractor', focusTypes: [] },
      { name: 'Drywall Contractor', focusTypes: [] },
      { name: 'Insulation Contractor', focusTypes: [] },
      { name: 'Window & Door Installation', focusTypes: [] },
      { name: 'Cabinet Maker/Installer', focusTypes: [] },
      { name: 'Countertop Fabricator', focusTypes: [] },
      { name: 'Custom Home Builder', focusTypes: [] },
      { name: 'ADU/Granny Flat Builder', focusTypes: [] },
      { name: 'Demolition Contractor', focusTypes: [] },
      { name: 'Excavation Contractor', focusTypes: [] },
      { name: 'Paving Contractor', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Financial Services',
    professions: [
      {
        name: 'Financial Advisor/Planner',
        focusTypes: [
          'Retirement Planning',
          'Investment Management',
          'Estate Planning',
          'Tax Planning',
          'Wealth Management',
        ],
      },
      {
        name: 'Accountant/CPA',
        focusTypes: [
          'Tax Preparation (Individual)',
          'Tax Preparation (Business)',
          'Bookkeeping',
          'Audit Services',
          'Forensic Accounting',
        ],
      },
      {
        name: 'Mortgage Broker/Lender',
        focusTypes: [
          'Conventional Loans',
          'FHA/VA Loans',
          'Refinancing',
          'Commercial Mortgages',
          'Reverse Mortgages',
        ],
      },
      {
        name: 'Insurance Agent',
        focusTypes: [
          'Auto Insurance',
          'Home Insurance',
          'Life Insurance',
          'Health Insurance',
          'Commercial Insurance',
          'Medicare',
        ],
      },
      { name: 'Tax Professional', focusTypes: [] },
      { name: 'Bookkeeper', focusTypes: [] },
      { name: 'Credit Repair', focusTypes: [] },
      { name: 'Debt Consolidation', focusTypes: [] },
      { name: 'Business Loan Broker', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Real Estate',
    professions: [
      {
        name: 'Real Estate Agent/Broker',
        focusTypes: [
          'Residential',
          'Commercial',
          'Luxury Properties',
          'Investment Properties',
          'Land/Lots',
        ],
      },
      { name: 'Property Manager', focusTypes: [] },
      { name: 'Real Estate Appraiser', focusTypes: [] },
      { name: 'Real Estate Attorney', focusTypes: [] },
      { name: 'Title Company', focusTypes: [] },
      { name: 'Escrow Services', focusTypes: [] },
      { name: 'Home Stager', focusTypes: [] },
      { name: 'Real Estate Investor', focusTypes: [] },
      { name: 'Real Estate Wholesaler', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Beauty & Personal Care',
    professions: [
      { name: 'Hair Salon/Stylist', focusTypes: [] },
      { name: 'Barbershop', focusTypes: [] },
      { name: 'Nail Salon/Nail Tech', focusTypes: [] },
      { name: 'Esthetician/Skincare', focusTypes: [] },
      { name: 'Makeup Artist', focusTypes: [] },
      { name: 'Massage Therapist', focusTypes: [] },
      { name: 'Spa & Wellness', focusTypes: [] },
      { name: 'Tattoo Artist', focusTypes: [] },
      { name: 'Permanent Makeup', focusTypes: [] },
      { name: 'Waxing/Hair Removal', focusTypes: [] },
      { name: 'Tanning Salon', focusTypes: [] },
      { name: 'Med Spa', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Professional Services',
    professions: [
      { name: 'Consultant', focusTypes: [] },
      { name: 'Marketing Agency', focusTypes: [] },
      { name: 'IT Services', focusTypes: [] },
      { name: 'Web Designer/Developer', focusTypes: [] },
      { name: 'Graphic Designer', focusTypes: [] },
      {
        name: 'Photographer',
        focusTypes: ['Portrait', 'Wedding', 'Commercial/Product', 'Real Estate', 'Event'],
      },
      {
        name: 'Videographer',
        focusTypes: ['Wedding', 'Commercial', 'Corporate', 'Event'],
      },
      { name: 'Event Planner', focusTypes: [] },
      { name: 'Caterer', focusTypes: [] },
      { name: 'DJ/Entertainment', focusTypes: [] },
      { name: 'Florist', focusTypes: [] },
      { name: 'Interior Designer', focusTypes: [] },
      { name: 'Architect', focusTypes: [] },
      { name: 'Engineer', focusTypes: [] },
      { name: 'Surveyor', focusTypes: [] },
      { name: 'Translation Services', focusTypes: [] },
      { name: 'Staffing Agency', focusTypes: [] },
      { name: 'Business Coach', focusTypes: [] },
      { name: 'Executive Coach', focusTypes: [] },
      { name: 'Career Coach', focusTypes: [] },
      { name: 'Resume Writer', focusTypes: [] },
      { name: 'Private Investigator', focusTypes: [] },
      { name: 'Security Services', focusTypes: [] },
      { name: 'Answering Service', focusTypes: [] },
      { name: 'Virtual Assistant', focusTypes: [] },
      { name: 'Printing Services', focusTypes: [] },
      { name: 'Signage Company', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Education & Training',
    professions: [
      {
        name: 'Tutor',
        focusTypes: ['Math/Science', 'Reading/Writing', 'Test Prep (SAT/ACT/GRE)', 'Special Needs'],
      },
      {
        name: 'Music Teacher/Lessons',
        focusTypes: ['Piano', 'Guitar', 'Voice', 'Drums', 'Violin', 'Other Instruments'],
      },
      { name: 'Dance Instructor/Studio', focusTypes: [] },
      { name: 'Martial Arts Instructor', focusTypes: [] },
      { name: 'Driving Instructor', focusTypes: [] },
      { name: 'Art Teacher', focusTypes: [] },
      { name: 'Language Tutor', focusTypes: [] },
      { name: 'Sports Coach', focusTypes: [] },
      { name: 'Yoga Instructor', focusTypes: [] },
      { name: 'Pilates Instructor', focusTypes: [] },
      { name: 'ACT/SAT Prep', focusTypes: [] },
      { name: 'Trade School', focusTypes: [] },
      { name: 'Professional Development Trainer', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Fitness & Wellness',
    professions: [
      {
        name: 'Personal Trainer',
        focusTypes: ['Weight Loss', 'Strength Training', 'Athletic Performance', 'Senior Fitness'],
      },
      { name: 'Gym/Fitness Center', focusTypes: [] },
      { name: 'CrossFit Box', focusTypes: [] },
      { name: 'Yoga Studio', focusTypes: [] },
      { name: 'Pilates Studio', focusTypes: [] },
      { name: 'Spin/Cycling Studio', focusTypes: [] },
      { name: 'Boxing/Kickboxing Gym', focusTypes: [] },
      { name: 'Martial Arts Studio', focusTypes: [] },
      { name: 'Weight Loss Coach', focusTypes: [] },
      { name: 'Nutrition Coach', focusTypes: [] },
      { name: 'Life Coach', focusTypes: [] },
      { name: 'Wellness Coach', focusTypes: [] },
      { name: 'Physical Therapy Clinic', focusTypes: [] },
      { name: 'Sports Performance Training', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Pet Services',
    professions: [
      {
        name: 'Veterinarian',
        focusTypes: ['General Practice', 'Emergency/Critical Care', 'Exotic Animals'],
      },
      { name: 'Dog Trainer', focusTypes: [] },
      { name: 'Pet Groomer', focusTypes: [] },
      { name: 'Dog Walker', focusTypes: [] },
      { name: 'Pet Sitter', focusTypes: [] },
      { name: 'Pet Boarding', focusTypes: [] },
      { name: 'Mobile Vet', focusTypes: [] },
      { name: 'Pet Photography', focusTypes: [] },
      { name: 'Pet Waste Removal', focusTypes: [] },
      { name: 'Aquarium Services', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Senior & Care Services',
    professions: [
      {
        name: 'Senior Care/Home Care',
        focusTypes: ['Companion Care', 'Personal Care', 'Memory Care', 'Hospice Care'],
      },
      { name: 'Assisted Living Placement', focusTypes: [] },
      { name: 'Senior Move Manager', focusTypes: [] },
      { name: 'Medical Alert Services', focusTypes: [] },
      { name: 'Meal Delivery', focusTypes: [] },
      { name: 'Transportation Services', focusTypes: [] },
      { name: 'Care Manager/Advocate', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Childcare & Family Services',
    professions: [
      { name: 'Daycare/Childcare Center', focusTypes: [] },
      { name: 'In-Home Daycare', focusTypes: [] },
      { name: 'Nanny/Au Pair', focusTypes: [] },
      { name: 'Babysitter', focusTypes: [] },
      { name: 'After-School Program', focusTypes: [] },
      { name: 'Summer Camp', focusTypes: [] },
      { name: 'Party/Event Planning (Kids)', focusTypes: [] },
      { name: 'Doula/Birth Services', focusTypes: [] },
      { name: 'Lactation Consultant', focusTypes: [] },
      { name: 'Parenting Coach', focusTypes: [] },
      { name: 'Child Development Specialist', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Technology & Electronics',
    professions: [
      { name: 'Computer Repair', focusTypes: [] },
      { name: 'Phone/Tablet Repair', focusTypes: [] },
      { name: 'TV/Electronics Repair', focusTypes: [] },
      { name: 'Home Theater Installation', focusTypes: [] },
      { name: 'Smart Home Installation', focusTypes: [] },
      { name: 'Security System Installation', focusTypes: [] },
      { name: 'Satellite/Antenna Installation', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Travel & Transportation',
    professions: [
      { name: 'Travel Agent', focusTypes: [] },
      { name: 'Limousine/Car Service', focusTypes: [] },
      { name: 'Airport Shuttle', focusTypes: [] },
      { name: 'Medical Transportation', focusTypes: [] },
      { name: 'Courier/Delivery Service', focusTypes: [] },
      { name: 'Charter Bus', focusTypes: [] },
      { name: 'Private Jet Charter', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Funeral & Memorial Services',
    professions: [
      { name: 'Funeral Home', focusTypes: [] },
      { name: 'Cremation Services', focusTypes: [] },
      { name: 'Cemetery/Memorial Park', focusTypes: [] },
      { name: 'Monument/Headstone', focusTypes: [] },
      { name: 'Estate Sale Services', focusTypes: [] },
      { name: 'Grief Counselor', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Specialty Services',
    professions: [
      { name: 'Solar Installation', focusTypes: [] },
      { name: 'EV Charger Installation', focusTypes: [] },
      { name: 'Water Treatment/Purification', focusTypes: [] },
      { name: 'Custom Tailor/Alterations', focusTypes: [] },
      { name: 'Shoe Repair', focusTypes: [] },
      { name: 'Jewelry Repair', focusTypes: [] },
      { name: 'Watch Repair', focusTypes: [] },
      { name: 'Upholstery', focusTypes: [] },
      { name: 'Antique Restoration', focusTypes: [] },
      { name: 'Art Restoration', focusTypes: [] },
      { name: 'Music Instrument Repair', focusTypes: [] },
      { name: 'Boat/Marine Services', focusTypes: [] },
      { name: 'RV Services', focusTypes: [] },
      { name: 'Golf Cart Services', focusTypes: [] },
      { name: 'Drone Services', focusTypes: [] },
      { name: '3D Printing Services', focusTypes: [] },
      { name: 'Other', focusTypes: [] },
    ],
  },
  {
    industry: 'Other',
    professions: [{ name: 'Other', focusTypes: [] }],
  },
];

/**
 * Get all industry categories
 */
export const getIndustries = (): string[] => {
  return INDUSTRY_TAXONOMY.map((item) => item.industry);
};

/**
 * Get all professions for a given industry
 */
export const getProfessionsForIndustry = (industry: string): string[] => {
  const industryData = INDUSTRY_TAXONOMY.find(
    (item) => item.industry.toLowerCase() === industry.toLowerCase()
  );
  return industryData ? industryData.professions.map((p) => p.name) : [];
};

/**
 * Get all focus types for a given profession within an industry
 */
export const getFocusTypesForProfession = (industry: string, profession: string): string[] => {
  const industryData = INDUSTRY_TAXONOMY.find(
    (item) => item.industry.toLowerCase() === industry.toLowerCase()
  );
  if (!industryData) return [];

  const professionData = industryData.professions.find(
    (p) => p.name.toLowerCase() === profession.toLowerCase()
  );
  return professionData ? professionData.focusTypes : [];
};

/**
 * Check if a profession has focus types
 */
export const professionHasFocusTypes = (industry: string, profession: string): boolean => {
  const focusTypes = getFocusTypesForProfession(industry, profession);
  return focusTypes.length > 0;
};

/**
 * Get all industries that contain a given profession name.
 * Used for reverse mapping when user selects profession first.
 */
export const getIndustriesForProfession = (professionName: string): string[] => {
  if (!professionName) return [];

  const matchingIndustries: string[] = [];
  for (const industryItem of INDUSTRY_TAXONOMY) {
    if (industryItem.professions.some((p) => p.name === professionName)) {
      matchingIndustries.push(industryItem.industry);
    }
  }
  return matchingIndustries;
};

/**
 * Get all unique profession names across all industries (sorted alphabetically).
 * Used when no industry is selected to show all available professions.
 */
export const getAllProfessionNames = (): string[] => {
  const professionSet = new Set<string>();
  for (const industryItem of INDUSTRY_TAXONOMY) {
    for (const profession of industryItem.professions) {
      professionSet.add(profession.name);
    }
  }
  return Array.from(professionSet).sort((a, b) => a.localeCompare(b));
};

/**
 * Build the display string for the legacy industry field
 */
export const buildIndustryDisplayString = (
  profession: string,
  focusTypes?: string | string[] | null
): string => {
  // Return only the profession/industry for cleaner display on business cards
  return profession;
};
